export default function makeOnCut(store) {
  return {
    onCut: function onCut(event, editor, next) {
      if (editor.value.selection.isCollapsed || !editor.isSelectionInTable()) {
        return next();
      }

      event.preventDefault();
      event.stopPropagation();
      editor.copyFragmentToClipboard(event, editor.value.fragment).emptyTableCellsAtSelection();
    },
    onDocumentCut: function onDocumentCut(event, editor) {
      var tableId = store.getItem('lastFocusedTableId');
      if (!tableId) return; // No table selected

      var cells = editor.getSelectedTableCells();
      editor.command('copyFragmentToClipboard', event, editor.getFragmentFromTableSelection()).emptyTableCells(cells);
    }
  };
}